module.exports = __webpack_public_path__ + "static/shopoint-aefdddfb39e109aa5d87c4a9f342aa2a.png";